<template>
  <!--编辑半成品-->
  <a-modal :title="title" :visible="visible" @cancel="cancel">
    <ak-inputs v-model="data" :options="options" ref="input" />
    <template slot="footer">
      <a-button @click="cancel">取消</a-button>
      <a-button :loading="loading" type="primary" @click="submit">确定</a-button>
    </template>
  </a-modal>
</template>

<script>
import store from '@/store'
// import NP from 'number-precision'
export default {
  data () {
    return {
      visible: false,
      oriPrice: null,
      oriRate: null,
      oriPriceGroup: [],
      finalPriceGroup: [],
      priceLog: [],
      loading: true,
      data: {
        name: this.record.name,
        price: this.record.price,
        rate: this.record.rate,
        describe: this.record.describe
      },
      logData: {
        name: this.record.name,
        user: store.state.user.name,
        describe: '',
        type: 'rawMaterial',
        reason: 'materialChanged'
      },
      oriTotalPrice: {
        price: 0,
        incidental: 0,
        profit: 0,
        adjustment: 0,
        total: 0
      },
      options: [
        {
          name: 'name',
          note: '名称',
          type: 'String',
          validators: [
            (val) => val ? null : '名称不可为空'
          ]
        },
        {
          name: 'price',
          note: '单价',
          type: ' Number',
          validators: [
            (val) => val ? null : '单价不可为空',
            (val) => {
              if (val <= 0) {
                return '请输入正确的单价'
              }
            }
          ]
        },
        {
          name: 'rate',
          note: '费率',
          type: 'Number',
          validators: [
            (val) => val ? null : '费率不可为空',
            (val) => {
              if (val <= 0) {
                return '请输入正确的费率'
              }
            }
          ]
        },
        {
          name: 'describe',
          note: '描述',
          type: 'String'
        },
      ]
    }
  },
  created () {
    this.unWatch = this.$watch(() => this.oriPriceGroup, this.listenConfirm)
    this.unWatch1 = this.$watch(() => this.oriPriceGroup, this.dataQuery)
  },
  async mounted () {
    this.dataQuery()
    this.oriPrice = this.record.price
    this.oriRate = this.record.rate
    this.oriDescribe = this.record.describe
    // 计算原公布价
    let { data: q } = await this.$tkParse.post('/totalPrice', this.record.objectId).catch(e => {
      this.$loading.hide()
      this.visible = false
      this.$notification['error']({
        message: '查询失败',
        description: '请重试'
      })
    })
    this.oriPriceGroup = q
    console.log(this.oriPriceGroup)
  },
  methods: {
    // 提示数据查询中
    dataQuery () {
      if (this.loading) {
        this.$loading.show('查询数据中，请稍后')
      } else {
        this.$loading.hide()
        this.visible = true
      }
    },
    // 确定按钮的旋转
    async listenConfirm () {
      if (this.oriPriceGroup) {
        this.loading = false
      }
    },
    async submit () {
      this.loading = true
      if (this.oriPrice !== this.data.price || this.oriRate !== this.data.rate) {
        this.data.price = parseFloat(this.data.price)
        this.data.rate = parseFloat(this.data.rate)
        await this.$modelAjax.put('rawMaterial', this.record.objectId, this.data)
        //     // 修改价格日志
        if (this.oriPrice !== this.data.price) {
          this.logData.describe = '由' + this.oriPrice + '变为' + this.data.price
          await this.$modelAjax.post('priceLog', this.logData).catch(e => {
            throw this.$notification['error']({
              message: '保存失败',
              description: '修改失败，请重新尝试'
            })
          })
        }
        // 重新计算公布价
        let { data: u } = await this.$tkParse.post('/totalPrice', this.record.objectId)
        this.finalPriceGroup = u
        for (let x in this.oriPriceGroup) {
          for (let y in this.finalPriceGroup) {
            if ((this.oriPriceGroup[x].objectId === this.finalPriceGroup[y].objectId) && (this.oriPriceGroup[x].price !== this.finalPriceGroup[y].price)) {
              // 提交价格日志
              let log = {
                name: '',
                type: '',
                oriPrice: '',
                price: '',
                user: store.state.user.name,
                reason: 'materialChanged',
                describe: ''
              }
              log.oriPrice = this.oriPriceGroup[x].price
              log.name = this.oriPriceGroup[x].name
              log.price = this.finalPriceGroup[y].price
              log.describe = '由' + log.oriPrice + '变为' + log.price
              if (this.finalPriceGroup[y].isBatching) {
                log.type = 'batchingFinishProduct'
              } else {
                log.type = 'finishProduct'
              }
              this.priceLog.push(log)
            }
          }
        }
        try {
          await this.$tkParse.post('/totalPrice/toPriceLog', this.priceLog)
          this.$notification['success']({
            message: '保存成功',
            description: '数据已保存'
          })
        } catch (e) {
          this.$notification['error']({
            message: '保存失败',
            description: '网络错误，请重新保存'
          })
        }
      } else {
        await this.$modelAjax.put('rawMaterial', this.record.objectId, this.data)
      }
      this.vm.refresh()
      this.$emit('complete', 'cancel')
    },
    cancel () {
      this.$emit('complete', 'cancel')
    },
  },
  props: {
    vm: null,
    record: Object, // 当前编辑的整条数据，注意这个数据是实时的，也就是其他字段被修改时，同样能捕捉到
    value: null, // 当前这个字段的值，如果这个字段是虚构的，则必定是空
    model: Object, // 当前model对象
    field: Object, // 当前field对象
    title: String
  }
}
</script>

<style scoped lang="scss">
  ::v-deep .ant-form-item-label > label::after {
    content: none !important;
  }
</style>
